import _Vue, { PluginFunction } from 'vue';
//import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css';
//import VueI18n from 'vue-i18n';

// Import vue components
import * as components from './lib-components/index';
import * as mixins from './mixins/index';

// Define typescript interfaces for autoinstaller
// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface InstallFunction extends PluginFunction<any> {
  installed?: boolean;
}

// install function executed by Vue.use()
const install: InstallFunction = function installFlightpathComponents(Vue: typeof _Vue) {
  if (install.installed) return;
  install.installed = true;
  //_Vue.use(Vuetify);
  //_Vue.use(VueI18n);

  Object.entries(components).forEach(([componentName, component]) => {
    Vue.component(componentName, component);
  });

  Object.entries(mixins).forEach(([componentName, component]) => {
    Vue.component(componentName, component);
  });
};

// Create module definition for Vue.use()
const plugin = {
  install
};

// To auto-install on non-es builds, when vue is found
// eslint-disable-next-line no-redeclare
/* global window, global */
if ('false' === String(process.env.ES_BUILD)) {
  let GlobalVue: typeof _Vue | null = null;
  if (typeof window !== 'undefined') {
    GlobalVue = window.Vue;
  } else if (typeof global !== 'undefined') {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    GlobalVue = (global as any).Vue;
  }
  if (GlobalVue) {
    (GlobalVue as typeof _Vue).use(plugin);
  }
}
// Default export is library as a whole, registered via Vue.use()
export default plugin;

// To allow individual component use, export components
// each can be registered via Vue.component()
export * from './lib-components/index';
export * from './mixins/index';
